export const educations = [
    {
        "studyType": "MCA",
        "endDate": "2016",
        "institution": "SRM Valliammai Engineering College",
        "location": "Kattankulathur",
        "area": "Computer Science",
        "startDate": "2014"
    },
    {
        "institution": "Pachiyappa's College For Men",
        "location": "Kanchipuram",
        "studyType": "BCA",
        "area": "Computer Science",
        "startDate": "2011",
        "endDate": "2014"
    }
]